import type { SubscriptionTier } from "@poseref/shared";

export interface QuotaDialogArgs {
  usedBytes: number;
  limitBytes: number;
  tier: SubscriptionTier;
  attemptedBytes: number;
}

type StorageQuotaDialogSink = (args: QuotaDialogArgs) => void;

let showDialog: StorageQuotaDialogSink | null = null;
let pendingDialog: QuotaDialogArgs | null = null;

/** Show the storage quota dialog. Call when a quota check fails. */
export function showStorageQuotaDialog(
  usedBytes: number,
  limitBytes: number,
  tier: SubscriptionTier,
  attemptedBytes: number,
): void {
  const args = { usedBytes, limitBytes, tier, attemptedBytes };
  if (showDialog) {
    showDialog(args);
  } else {
    pendingDialog = args;
  }
}

export function registerStorageQuotaDialogSink(
  sink: StorageQuotaDialogSink,
): () => void {
  showDialog = sink;
  if (pendingDialog) {
    sink(pendingDialog);
    pendingDialog = null;
  }
  return () => {
    if (showDialog === sink) {
      showDialog = null;
    }
  };
}
